export enum AccountSettingsConditional {
    UNSET = 'UNSET',
    AND = 'AND',
    OR = 'OR',
}

export default AccountSettingsConditional;
